import { useMemo } from 'react';
import { getTextColor } from '$theme';
import { LoadingSpinner } from '~/shared/components/LoadingSpinner';
import {
    CloseIcon,
    StyledInfoLink,
    StyledInfoText,
    StyledNotification,
    StyledTitle,
    StyledNotificationContent,
    CustomLink,
} from './styles';
import { NotificationProp } from './types';

export type { NotificationProp } from './types';

export const ProductNotification = ({
    backgroundColor,
    borderColor,
    centered,
    content,
    isLoading,
    link,
    textColor,
    onClose,
    title,
    variant,
    closeNotification = false,
    className,
}: NotificationProp) => {
    const memoTextColor = useMemo(
        () =>
            textColor ? ensureHexColor(textColor) : ensureHexColor(getTextColor(backgroundColor)),
        [backgroundColor, textColor],
    );

    const isInternalLink = link?.target === '_self' || link?.target === '';

    return (
        <StyledNotification
            className={className}
            centered={centered}
            variant={variant}
            backgroundColor={ensureHexColor(backgroundColor)}
            textColor={memoTextColor}
            closeNotification={closeNotification}
            hasCloseIcon={!!onClose}
            borderColor={borderColor}
        >
            <StyledNotificationContent>
                {title ? <StyledTitle>{title}</StyledTitle> : null}

                {isLoading || content ? (
                    <StyledInfoText>{isLoading ? <LoadingSpinner /> : content}</StyledInfoText>
                ) : null}

                {link?.url && link.text ? (
                    isInternalLink ? (
                        <StyledInfoLink href={link.url} target="_self" prefetch={false}>
                            {link.text}
                        </StyledInfoLink>
                    ) : (
                        <CustomLink color={memoTextColor} href={link.url} target="_blank">
                            {link.text}
                        </CustomLink>
                    )
                ) : null}
            </StyledNotificationContent>
            {onClose ? <CloseIcon onClick={onClose} /> : null}
        </StyledNotification>
    );
};

export const ensureHexColor = (colorString?: string) =>
    colorString ? (colorString.startsWith('#') ? colorString : `#${colorString}`) : colorString;
